import * as BASE from './base';

const base_url = process.env.REACT_APP_API_HOST;

export function AdminSessionsList() {
    return BASE.POST('api/sessionsList', {});
}

export function AdminSessionDetails(sessionId) {
    return BASE.POST('api/sessionDetails', { sessionId });
}

export function AdminSessionsScan() {
    return BASE.POST('api/sessionsScan', {});
}

export function AdminChangeSessionStatus(sessionId) {
    return BASE.POST('api/changeSessionStatus', { sessionId });
}

export function AdminUploadFile(file) {
     let formData = new FormData();
    formData.append("file", file);
    return BASE.POSTFile('api/uploadFile', formData);
}

export function AdminSetSessionDuration(sessionId, duration) {
    return BASE.POST('api/setSessionDuration', { sessionId, duration });
}

export function AdminConfirmUser(sessionId, userId, confirmed) {
    var data = { sessionId, userId, confirmed };
    return BASE.POST('api/adminConfirmUser', data);
}